const { toHTML } = require("@portabletext/to-html");
const { marked } = require("marked");

module.exports = ({ value, customComponents }) => {
  const footnoteItem = (index, reference) => `
    <li id="fn:${index}">
      ${marked.parseInline(toHTML(reference, { components: customComponents({prefix: null}) })).replace(/<\/p>/g, "")}
        <a class="footnote-return" href="#fnref:${index}">
          <svg xmlns="http://www.w3.org/2000/svg" class="typography/icon:after:270deg" viewBox="0 0 16 16">
            <path d="M2.5 8H13" fill="none" vector-effect="non-scaling-stroke"></path>
            <path d="M8 3l5 5-5 5" fill="none" vector-effect="non-scaling-stroke"></path>
          </svg>
        </a>
      </p>
    </li>
  `;

  return `
    <div class="footnotes">
      <ol>
        ${value.map(({ text }, index) => footnoteItem(index + 1, text)).join("")}
      </ol>
    </div>
  `;
};
